import { z } from 'zod';
// eslint-disable-next-line import/prefer-default-export
export var FormStateSchema = z.enum([
    'FAILURE',
    'VALIDATIONFAILURE',
    'INACTIVE',
    'LOADING',
    'SUCCESS'
]);
